/* eslint-disable react/prop-types */
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LeadGenerationContext from '../../../context/LeadGenerationContext';

function CatalogueWCInternal(props) {
  const location = useLocation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { entryProductType, entryProductName, language } = location.state || {};
  const { otpToken, initiateUiResponse } = leadGenerationContext;
  const elRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    // Keep your candidate order
    const candidates = [
      '/wc-CatalogueWCInitializer.js',
      '/dist/wc-CatalogueWCInitializer.js',
      '/static/js/wc-CatalogueWCInitializer.js',
      'dist/wc-CatalogueWCInitializer.js',
    ];

    function handleScriptLoad(resolve) {
      return () => resolve();
    }
    function handleScriptError(reject) {
      return () => reject(new Error('Failed to load script'));
    }
    function injectScriptSrc(url) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = url;
        s.defer = true;
        s.onload = handleScriptLoad(resolve);
        s.onerror = handleScriptError(reject);
        document.head.appendChild(s);
      });
    }
    function fetchCandidate(url) {
      return fetch(url, { cache: 'no-store' })
        .then((res) => ({ url, res }))
        .catch((err) => ({ url, err }));
    }
    function getCandidateText(item) {
      if (item.res?.ok) {
        return item.res.text().then((text) => ({
          url: item.url,
          text,
        }));
      }

      return Promise.resolve({
        url: item.url,
        text: null,
      });
    }
    function findValidBundle(texts) {
      for (const url of candidates) {
        const t = texts.find((x) => x.url === url);
        if (t?.text) {
          const preview = t.text.trim().slice(0, 20);
          if (preview.startsWith('<')) {
            console.warn('Catalogue bundle at', url, 'looks like HTML. Preview:', preview);
          } else {
            return url;
          }
        }
      }

      return null;
    }

    async function tryLoad() {
      try {
        const settled = await Promise.all(candidates.map(fetchCandidate));

        const texts = await Promise.all(settled.map(getCandidateText));

        const foundUrl = findValidBundle(texts);

        if (foundUrl) {
          // IMPORTANT: load by URL (no blob)
          await injectScriptSrc(foundUrl);
          if (!cancelled) {
            try {
              await customElements.whenDefined('sales-product-catalogue-wc');
              setLoaded(true);
            } catch (e) {
              setError(e);
            }
          }
          return;
        }

        if (!cancelled) {
          setError(
            new Error('Could not find a valid sales-product-catalogue-wc bundle in candidates')
          );
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
        }
      }
    }

    tryLoad();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (loaded && elRef.current && typeof elRef.current.renderWebComponent === 'function') {
      try {
        elRef.current.renderWebComponent({
          custIdToken: otpToken,
          lang: language,
          source: 'OMB',
          env: initiateUiResponse.REACT_APP_ENVIRONMENT,
          devicePlatform: '',
          wcFlow: true,
          salesData: {
            location: 'PR',
            productType: entryProductType,
            productName: entryProductName,
          },
        });
      } catch (e) {
        console.error('renderWebComponent call failed', e);
      }
    }
  }, [loaded, otpToken, language]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {error && (
        <div style={{ padding: 16 }}>
          <strong>Webcomponent load error:</strong>
          <div>{String(error)}</div>
        </div>
      )}
      <div style={{ width: '100%', height: '100%' }}>
        <sales-product-catalogue-wc ref={elRef} />
      </div>
    </div>
  );
}

export default CatalogueWCInternal;
